import { gql } from '@apollo/client';

const schema = {
  loginAs: {
    name: 'loginAs',
    serviceName: 'shopadmin',
    query: gql`
      mutation loginAs($cellphone: String!) {
        loginAs(cellphone: $cellphone) {
          user {
            token
            roles
            username
            cellphone
            permission_names
          }
          messages
        }
      }
    `,
  },
};

export default schema;
